import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance";
import { MantineReactTable } from "mantine-react-table";
import { Box, ActionIcon, Tooltip } from "@mantine/core";
import { IconCopy, IconDownload, IconEye } from "@tabler/icons-react";
import { ExportToCsv } from "export-to-csv";
import { IconTrash, IconEdit } from "@tabler/icons-react";
import moment from "moment";
import swal from "sweetalert2";
import Pagination from "rc-pagination";
import { CircularProgress } from "@material-ui/core";
import { toast } from 'react-toastify';
const useStyles = makeStyles(styles);

export default function ManagePromotion() {
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});
  console.log(pagination, "paginationpagination")
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const classes = useStyles();
  const columns = useMemo(() => [
    {
      header: "Promotion Id",
      accessorKey: "_id",
      size: 10,
    },
    {
      header: "Reward By",
      accessorKey: "rewardBy",
      size: 10,
    },
    {
      header: "Coupon Code",
      accessorKey: "couponCode",
      size: 10,
    },
    {
      header: "Reward Amount",
      accessorKey: "rewardAmount",
      size: 10,
    },
    {
      header: "Start Date & Time",
      accessorKey: "startDateTime",
      size: 10,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return moment(value).isValid()
          ? moment(value).local().format("YYYY-MM-DD hh:mm A")
          : "Invalid Date";
      },
    },
    {
      header: "End Date & Time",
      accessorKey: "endDateTime",
      size: 10,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return moment(value).isValid()
          ? moment(value).local().format("YYYY-MM-DD hh:mm A")
          : "Invalid Date";
      },
    },

  ]);

  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});
  const [tableData, setTableData] = useState([]);
  console.log(tableData, "tableData");
  useEffect(() => {
    getData(page, limit);
  }, [page, limit, location.state?.refresh]);

  const handleOpenEditModal = async (row) => {
    console.log(row._valuesCache.rewardBy, "hhh")
    if (row._valuesCache.rewardBy === "Buy Tickets") {
      navigate(`editPromotions/BuyTicket/${row._valuesCache._id}`);
    }
    else if (row._valuesCache.rewardBy === "Community") {
      navigate(`editPromotions/CommunityPromotions/${row._valuesCache._id}`);
    }
    else {
      navigate(`editPromotions/UserRegistration/${row._valuesCache._id}`);
    }
  };
  const getData = async (page = 1, limit = 10) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    console.log(token);
    await axios
      .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/promotion`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params: {
          page,
          limit,
        },
      })
      .then((res) => {
        console.log(res);
        const data = res.data.data;
        setUsers(data);
        setTableData(data);
        setPagination(res.data.pagination);
        console.log(users);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }).finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = async (row) => {
    const token = localStorage.getItem("token");

    const result = await swal.fire({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/promotionremove/${row._valuesCache._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        console.log(response);
        swal.fire("Deleted!", "You have successfully deleted!", "success");
        getData();
      } catch (error) {
        if (error?.response?.status === 403) {
          await swal.fire({
            icon: "error",
            title: "Error",
            text: "You do not have permission to delete this promotion.",
          });
        } else {
          swal.fire({
            icon: "error",
            text: "error.",
          });
        }
      }
    } else {
      swal.fire("Cancelled", "Details are not deleted", "info");
    }
  };

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    const token = localStorage.getItem("token");
    if (!Object.keys(validationErrors).length) {
      tableData[row.index] = values;
      setTableData([...tableData]);
      exitEditingMode();
      let formDataValue = {
        rewardBy: values.rewardBy,
        couponCode: values.couponCode,
        rewardAmount: values.rewardAmount,
        startDate: values.startDateTime,
        endDate: values.endDateTime,
        // userType: values.userType,
        // mobileNumber: values.mobileNumber,
      };
      await axios
        .put(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/promotion/${row._valuesCache._id}`,
          formDataValue,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((res) => {
          console.log(res);
        })

        .catch((err) => {
          console.log(err);
          if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
            localStorage.removeItem("token");
            window.location.assign("/auth/login-page");
          }
        });
    }
  };

  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers: columns.map((c) => c.header),
  };

  const csvExporter = new ExportToCsv(csvOptions);

  const handleExportRows = (rows) => {
    csvExporter.generateCsv(rows.map((row) => row.original));
  };

  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };


  const editPromotionPaths = [
    "/admin/ManagePromotion/editPromotions/BuyTicket",
    "/admin/ManagePromotion/createPromotion/buyTicket",
    "/admin/ManagePromotion/editPromotions/UserRegistration",
    "/admin/ManagePromotion/createPromotion/UserRegistration",
    "/admin/ManagePromotion/createPromotion/CommunityPromotions",
    "/admin/ManagePromotion/editPromotions/CommunityPromotions",
  ];

  const isEditPromotionPath = editPromotionPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  if (isEditPromotionPath) {
    return <Outlet />;
  }
  const updatePage = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Manage Promotion</h4>
              <Button
                color="#3C37FF"
                style={{ float: "right", marginTop: "20px" }}
                onClick={() => navigate("/admin/ManagePromotion/createPromotion/buyTicket")}
              >Add Promotion (Buy Ticket)</Button>
              <Button
                color="#3C37FF"
                style={{ float: "right", marginRight: "10px", marginTop: "20px" }}
                onClick={() => navigate("/admin/ManagePromotion/createPromotion/UserRegistration")}
              >Add Promotion (User Registration)</Button>
              <Button
                color="#3C37FF"
                style={{ float: "right", marginRight: "10px", marginTop: "20px" }}
                onClick={() => navigate("/admin/ManagePromotion/createPromotion/CommunityPromotions")}
              >community promotion</Button>
            </CardHeader>

            {!loading ? (<CardBody>
              <MantineReactTable
                columns={columns}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    mantineTableHeadCellProps: {
                      align: "center",
                    },
                    size: 120,
                  },
                }}
                enableColumnFilterModes
                enablePagination={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enableDensityToggle={false}
                enableFilters={false}
                initialState={{ showColumnFilters: true }}
                positionToolbarAlertBanner="bottom"
                data={tableData}
                enableEditing
                onEditingRowSave={handleSaveRowEdits}
                onEditingRowCancel={handleCancelRowEdits}
                positionActionsColumn="first"

                renderRowActions={({ row, table }) => {
                  // Your base URL (make sure it's set in your env)
                  const baseUrl = process.env.REACT_APP_REGISTER_URL || "https://staging.mervcryptofortune.com/auth/register";

                  // Get the promotion data from the row
                  const promo = row.original;

                  // Construct the community promotion link if type matches
                  const communityLink = promo.promotionType === 'community_promotion'
                    ? `${baseUrl}?communityToken=${encodeURIComponent(promo.communityToken)}`
                    : null;

                  const copyToClipboard = (text) => {
                    if (!navigator.clipboard) {
                      alert('Clipboard API not supported in this browser');
                      return;
                    }
                    navigator.clipboard.writeText(text)
                      .then(() => {
                       toast.success('Promotion link copied to clipboard!');
                      })
                      .catch((err) => {
                        console.error('Failed to copy: ', err);
                        alert('Failed to copy link: ' + err.message);
                      });
                  };


                  return (
                    <Box sx={{ display: "flex", gap: "16px" }}>
                      <Tooltip withArrow position="left" label="Edit">
                        <ActionIcon onClick={() => handleOpenEditModal(row)}>
                          <IconEdit />
                        </ActionIcon>
                      </Tooltip>

                      <Tooltip withArrow position="right" label="Delete">
                        <ActionIcon color="red" onClick={() => handleDelete(row)}>
                          <IconTrash />
                        </ActionIcon>
                      </Tooltip>

                      {/* Show copy button only for community promotion */}
                      {communityLink && (
                        <Tooltip withArrow position="right" label="Copy Promotion Link">
                          <ActionIcon color="blue" onClick={() => copyToClipboard(communityLink)}>
                            <IconCopy />
                          </ActionIcon>
                        </Tooltip>
                      )}
                    </Box>
                  );
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                }}
              >
                <Pagination
                  pageSize={pagination?.itemsPerPage || 10}
                  current={page}
                  total={pagination?.totalItems || 0}
                  onChange={updatePage}
                />

              </Box>
            </CardBody>) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px",
                  width: "100%",
                }}
              >
                <CircularProgress size={60} />
              </div>
            )}
          </Card>
        </GridItem>
      </GridContainer>
      <Outlet /></>
  );
}
